export const permissionOptions = [
  { label: 'Scope-based', value: 'scope' },
  { label: 'Resource-based', value: 'resource' },
];
